// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z2F0G","toggle":"styles_toggle__hDyC4","preview":"styles_preview__3ByGA"};